import React, { useState } from 'react';
import CurrentEvents from './CurrentEvents';
import HistoryEvents from './HistoryEvents';

// Css module imports
import classes from '../../SmartCharging/SmartCharging.module.css';
import TabsComponent from '../../../components/Tabs/Tabs';

const Events = ({
    instances,
    licenseTypeId,
    updateQueryParams,
    queryParamsData
}) => {

    const [selectedIndex, setSelectedIndex] = useState(queryParamsData.subTab ? queryParamsData.subTab : 0);

    const tabs = [
        {
            name: 'Current',
            component: (
                <CurrentEvents
                    instances={instances}
                    licenseTypeId={licenseTypeId}
                    updateQueryParams={updateQueryParams}
                    queryParamsData={queryParamsData}
                />
            ),
        },
        {
            name: 'History',
            component: (
                <HistoryEvents
                    instances={instances}
                    licenseTypeId={licenseTypeId}
                    updateQueryParams={updateQueryParams}
                    queryParamsData={queryParamsData}
                />
            ),
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <div className={classes.Ventilation + ' ventilation'}>
                <TabsComponent
                    selectedIndex={selectedIndex}
                    tabs={tabs}
                    onChangeTab={(index) => {
                        setSelectedIndex(index);
                        updateQueryParams('subTab', index);
                    }}
                />
            </div>
        </div>
    );
};

export default Events;